<div class="flex flex-col items-center justify-center h-[100vh] min-h-[400px] p-8">
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="50" stroke="#253A81" stroke-width="2" fill="none" opacity="0.2" />
    <path d="M60 30V60L75 75" stroke="#253A81" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <h2 class="text-2xl font-semibold text-[#253A81] mt-6">Coming Soon</h2>
  <p class="text-[#6B6B6A] text-center mt-2 max-w-md">
    This feature is currently under development and will be available soon.
  </p>
</div>